import { NotificationService } from "@3gaam/api/services";
import { RegisterClientOutput } from "@3gaam/api/types/notification";
import { firebaseConfig, VAPID } from "@3gaam/capp/src/config";
import { store } from "@3gaam/capp/src/store";
import { addMessageAction } from "@3gaam/capp/src/store/message";
import logo from "@3gaam/shared/assets/images/logo-green.svg";
import { handleFirebase } from "@3gaam/shared/utils/firebase";
import { MessagePayload } from "firebase/messaging";

let version = process.env.REACT_APP_VERSION;

export function handleMessages() {
  if ("serviceWorker" in navigator) {
    const createNotification = (firebaseMessage: MessagePayload) => {
      if (Notification?.permission !== "granted") return;
      const notif = new Notification(
        firebaseMessage.notification?.title || "پیام جدید",
        {
          body: firebaseMessage.notification?.title,
          icon: logo,
        },
      );

      notif.addEventListener("click", () => {
        window.location.href =
          //@ts-ignore
          firebaseMessage.notification?.click_action ||
          firebaseMessage.fcmOptions?.link ||
          "/";
      });
    };

    const newMessageHandler = (firebaseMessage: MessagePayload) => {
      store.dispatch(addMessageAction(firebaseMessage));

      if (!store.getState().message.notification.disabled) {
        try {
          createNotification(firebaseMessage);
        } catch (error) {
          console.error("Need Notification Permission");
        }
      }
    };

    const notificationData = JSON.parse(
      localStorage.getItem("notificationData") || "{}",
    ) as RegisterClientOutput;

    const changeKeyHandler = (curKey: string) => {
      NotificationService.register({
        ClientType: "PANEL",
        CurrentClientId: notificationData?.ClientId || null,
        FcmToken: curKey,
        VersionName: version,
      })
        .then((res) => {
          localStorage.setItem("notificationData", JSON.stringify(res.data));
        })
        .catch(() => {
          localStorage.setItem(
            "notificationData",
            JSON.stringify({ fcmToken: curKey }),
          );
        });
    };

    const shouldRefreshToken = () => {
      if (!notificationData?.Timestamp) {
        return true;
      }

      const _MS_PER_DAY = 1000 * 60 * 60 * 24;

      const daysSinceLastRefresh =
        (new Date().getTime() -
          new Date(notificationData.Timestamp).getTime()) /
        _MS_PER_DAY;

      return daysSinceLastRefresh >= 30;
    };

    handleFirebase(
      changeKeyHandler,
      newMessageHandler,
      firebaseConfig,
      VAPID,
      shouldRefreshToken(),
    );
  }
}
